<template>
  <div>
    <h3 class="section-title section-title--small">View on map</h3>
    <hr aria-hidden="true" class="devider" />
    <GoogleMap />
   <Tags />
  </div>
</template>

<script setup lang="ts">
import GoogleMap from "../components/product-page/GoogleMap.vue";
import Tags from "../components/product-page/Tags";

</script>
